export default __webpack_public_path__ + "static/media/Ethos3.f12e324c.jpg";